module.exports = "/assets/e54eaa8166534fb3e8919c4db4cb59d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VV.png
// module id = 3059
// module chunks = 0